
import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar",  
        },
        colors: ["#7664c9"],
        xaxis: {
          categories: ["1hr", "2hr", "3hr", "4hr"]
        }
      },
       series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50]
        }
      ]
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="line"
              width="450"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarChart3;

